import { useSocialStore } from "../../../stores/social";
import { useUserContext } from "../../../contexts/userContext";
import { useTranslation } from "react-i18next";

const TabArrayElements = () => {
  const { t } = useTranslation();
  const { tabElements, setTabElements, idCustomer } = useSocialStore();
  const { sc_UserToCustomerFile, typeRole } = useUserContext();

  const isAffectBulletin = sc_UserToCustomerFile.find(
    (customer: any) =>
      customer.idCustomerFile === idCustomer && customer.bulletin === true,
  );

  return (
    <div className="flex px-3 pt-2">
      <button
        className={`group relative cursor-pointer px-4 py-2 flex items-center gap-1.5 font-medium text-xs transition-all duration-200 ${
          tabElements === "Absences"
            ? "text-blue-600"
            : "text-gray-600 hover:text-gray-800"
        }`}
        onClick={() => setTabElements("Absences")}
      >
        <svg
          className={`w-4 h-4 transition-colors duration-200 ${
            tabElements === "Absences"
              ? "text-blue-600"
              : "text-gray-400 group-hover:text-gray-600"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>{t("Absences")}</span>
        {tabElements === "Absences" && (
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-linear-to-r from-blue-500 to-blue-600 rounded-full"></div>
        )}
      </button>

      {((typeRole === "Customer" && isAffectBulletin) || typeRole === "Company") ? (
        <button
          className={`group relative cursor-pointer px-4 py-2 flex items-center gap-1.5 font-medium text-xs transition-all duration-200 ${
            tabElements === "Valeurs"
              ? "text-blue-600"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setTabElements("Valeurs")}
        >
          <svg
            className={`w-4 h-4 transition-colors duration-200 ${
              tabElements === "Valeurs"
                ? "text-blue-600"
                : "text-gray-400 group-hover:text-gray-600"
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>{t("Valeurs")}</span>
          {tabElements === "Valeurs" && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-linear-to-r from-blue-500 to-blue-600 rounded-full"></div>
          )}
        </button>
      ) : null}
    </div>
  );
};

export default TabArrayElements;
